import { OVERLAY_CONST } from './Overlay.d';
import { Overlay } from './Overlay.styles';
import type { OverlayProps } from './Overlay.d';

const OverlayBase = ({ onClick, visible, isExtendedCaptation, ...props }: OverlayProps) => (
  <Overlay
    data-testid={OVERLAY_CONST.TEST_ID}
    data-visible={visible}
    data-extended-captation={isExtendedCaptation}
    onClick={onClick}
    {...props}
  />
);

export default OverlayBase;
